/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordResetAttestationData
 */
export interface PasswordResetAttestationData {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetAttestationData
     */
    password: string;
}

/**
 * Check if a given object implements the PasswordResetAttestationData interface.
 */
export function instanceOfPasswordResetAttestationData(value: object): value is PasswordResetAttestationData {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function PasswordResetAttestationDataFromJSON(json: any): PasswordResetAttestationData {
    return PasswordResetAttestationDataFromJSONTyped(json, false);
}

export function PasswordResetAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetAttestationData {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function PasswordResetAttestationDataToJSON(json: any): PasswordResetAttestationData {
    return PasswordResetAttestationDataToJSONTyped(json, false);
}

export function PasswordResetAttestationDataToJSONTyped(value?: PasswordResetAttestationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
    };
}

